import { extend } from 'umi-request';
import Udesk from 'Udesk';
import QualityInspectionListDetailComponent from './component';

class QualityInspectionListDetailRoute extends QualityInspectionListDetailComponent {
    async getInitData() {
        let { sdkOptions, match } = this.props;
        let callId = match.params.id;
        if (callId) {
            const latestDataUrl = Udesk.business.apiPath.concatApiPath(
                `/findLatestData/${callId}`,
                sdkOptions
            );
            try {
                const latestData = await Udesk.ajax.get(latestDataUrl);
                this.privates.id = latestData.data.id;
                this.privates.taskId = latestData.data.taskId;
                this.actions.update();
                if (this.privates.detail && !this.privates.detail.id) {
                    this.actions.reloadAsyncModel();
                }
            } catch (error) {
                Udesk.ui.notify.error(error.errorMsg);
                return {};
            }
        }

        if (!this.privates.id || !this.privates.taskId) {
            return {};
        }
    }
    init() {
        // 从URL参数中获取公共参数
        const urlParams = new URLSearchParams(window.location.search);
        const additionalParams = {
            email: urlParams.get('email') || '',
            timestamp: urlParams.get('timestamp') || '',
            sign: urlParams.get('sign') || '',
        };

        // 处理URL和参数的通用函数
        const processUrlAndParams = (url, method, data) => {
            if (url.includes('__processed=true')) {
                return { url, data };
            }

            let processedUrl = url.replace(
                '/backend/',
                `/api/v1/middleware/thirdparty/${urlParams.get('domain')}/`
            );
            const separator = processedUrl.includes('?') ? '&' : '?';
            processedUrl += `${separator}__processed=true`;
            processedUrl +=
                '&' + decodeURIComponent(new URLSearchParams(additionalParams).toString());
            return { url: processedUrl, data };
        };

        // jQuery 请求拦截
        if (window.jQuery) {
            window.jQuery.ajaxPrefilter((options, originalOptions, jqXHR) => {
                if (options.url) {
                    const processed = processUrlAndParams(
                        options.url,
                        options.type || 'GET',
                        options.data
                    );
                    options.url = processed.url;
                    options.data = processed.data;
                }
            });
        }

        // umi-request 拦截器
        const request = extend({});
        request.interceptors.request.use((url, options) => {
            const processed = processUrlAndParams(
                url,
                options.method || 'GET',
                options.data || options.body
            );

            return {
                url: processed.url,
                options: {
                    ...options,
                    data: processed.data,
                    body: processed.data,
                },
            };
        });

        // 将处理后的request实例挂载到全局
        window.g_app = window.g_app || {};
        window.g_app._store = window.g_app._store || {};
        window.g_app._store.fetch = request;
        this.getInitData();
    }
    asyncModel(changedParams) {
        let { sdkOptions, match } = this.props;
        let callId = match.params.id;

        if (!this.privates.id || !this.privates.taskId) {
            return {};
        }

        let urlData = {};
        this.privates.renderLoading = true;
        if (this.privates.detail.id) {
            this.privates.detail = {};
        }
        this.actions.update();
        let detailUrl = Udesk.business.apiPath.concatApiPath(
            `inspectionData/${this.privates.id}?taskId=${this.privates.taskId}`,
            sdkOptions
        );
        if (this.props.location && this.props.location.search) {
            urlData = Object.assign(
                {},
                this.props.match.params,
                Object.fromEntries(new URLSearchParams(this.props.location.search))
            );
            if (urlData.highLightType && urlData.highLightType === '1') {
                detailUrl = Udesk.business.apiPath.concatApiPath(
                    `inspectionData/${this.privates.id}?taskId=${this.privates.taskId}&highLightType=${urlData.highLightType}`,
                    sdkOptions
                );
            }
        }
        let detailPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(detailUrl).then(
                (resp) => {
                    resolve({ detail: resp });
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });

        let smartTagsUrl = Udesk.business.apiPath.concatApiPath(
            `callTags/${callId}/tagsOfCall`,
            sdkOptions
        );
        Udesk.ajax.get(smartTagsUrl).then(
            (resp) => {
                this.privates.smartTags = resp.data;
                this.actions.update();
            },
            (reason) => {
                Udesk.ui.notify.error(reason.errorMsg);
            }
        );
        let checkPointsPromise = new Promise((resolve, reject) => {
            let checkPointsUrl = Udesk.business.apiPath.concatApiPath(
                `inspectionData/${this.privates.taskId}/pointList`,
                sdkOptions
            );
            Udesk.ajax.get(checkPointsUrl).then(
                (resp) => {
                    resolve(resp.data);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });

        return {
            detailWithRelateData: detailPromise,
            checkPoints: checkPointsPromise,
        };
    }
}

export default QualityInspectionListDetailRoute;
